export default "__VITE_ASSET__28d239fd__"